(function(){
  'use strict';
  const root=document.querySelector('[data-crtx-page]');
  if(!root)return;
  const preference=window.matchMedia('(prefers-reduced-motion: reduce)');
  let cleanup=()=>{};
  function start(){
    cleanup();
    if(preference.matches)return;
    root.classList.add('motion-ready');
    const reveals=[...root.querySelectorAll('.reveal')];
    const revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(entry.isIntersecting){entry.target.classList.add('visible');revealObserver.unobserve(entry.target);}
    }),{threshold:.08,rootMargin:'0px 0px -25px 0px'});
    reveals.forEach(element=>revealObserver.observe(element));
    const product=root.querySelector('[data-scroll-product]');
    const formula=root.querySelector('.formula-layout');
    const hero=root.querySelector('[data-hero-glow]');
    let frame=0;
    let active=false;
    let heroActive=false;
    const render=()=>{
      frame=0;
      if(heroActive){
        const r=hero.getBoundingClientRect();
        const start=Math.max(0,r.top+scrollY-innerHeight*.72);
        const progress=Math.max(0,Math.min(1,(scrollY-start)/Math.min(360,innerHeight*.45)));
        hero.style.setProperty('--hero-glow',progress.toFixed(3));
      }
      if(active){
        const r=formula.getBoundingClientRect();
        const progress=Math.max(0,Math.min(1,(innerHeight-r.top)/(innerHeight+r.height)));
        product.style.setProperty('--formula-glow',Math.max(0,Math.min(1,progress*1.65)).toFixed(3));
        product.style.setProperty('--scroll-yaw',(-12+progress*24)+'deg');
        product.style.setProperty('--scroll-roll',(-9+progress*17)+'deg');
        product.style.setProperty('--scroll-lift',(18-progress*36)+'px');
      }
    };
    const queue=()=>{if(!frame&&(active||heroActive))frame=requestAnimationFrame(render);};
    const productObserver=new IntersectionObserver(entries=>{active=entries[0].isIntersecting;queue();},{rootMargin:'100px'});
    productObserver.observe(formula);
    const heroObserver=new IntersectionObserver(entries=>{
      heroActive=entries[0].isIntersecting;queue();
    },{rootMargin:'100px'});
    heroObserver.observe(hero);
    window.addEventListener('scroll',queue,{passive:true});
    window.addEventListener('resize',queue,{passive:true});
    cleanup=()=>{
      revealObserver.disconnect();productObserver.disconnect();heroObserver.disconnect();
      root.classList.remove('motion-ready');
      window.removeEventListener('scroll',queue);window.removeEventListener('resize',queue);
      cancelAnimationFrame(frame);hero.style.removeProperty('--hero-glow');product.removeAttribute('style');
    };
  }
  if('IntersectionObserver' in window)start();
  preference.addEventListener('change',start);
})();

(function(){
  'use strict';
  const root=document.querySelector('[data-crtx-page]');
  if(!root||root.dataset.researchMotionInitialized)return;
  root.dataset.researchMotionInitialized='true';
  const cards=[...root.querySelectorAll('.study')];
  const preference=window.matchMedia('(prefers-reduced-motion: reduce)');
  const frames=new Map();
  const finalValues=new Map([...root.querySelectorAll('[data-count]')].map(element=>[element,element.textContent]));
  let observer=null;
  let metricObserver=null;
  function restore(card){
    card.style.removeProperty('--metric-progress');
    card.classList.remove('is-counting');
    card.querySelectorAll('[data-count]').forEach(element=>{element.textContent=finalValues.get(element);});
  }
  function animate(card,index){
    if(card.dataset.counted==='true')return;
    card.dataset.counted='true';
    card.classList.add('is-counting');
    const values=[...card.querySelectorAll('[data-count]')].map(element=>({element,target:Number(element.dataset.count),decimals:Number(element.dataset.decimals||0),prefix:element.dataset.prefix||''}));
    const begin=performance.now()+index*100;
    const duration=1650;
    const tick=now=>{
      const elapsed=Math.max(0,Math.min(1,(now-begin)/duration));
      const progress=1-Math.pow(1-elapsed,3);
      card.style.setProperty('--metric-progress',progress.toFixed(4));
      values.forEach(({element,target,decimals,prefix})=>{element.textContent=prefix+(target*progress).toFixed(decimals);});
      if(elapsed<1)frames.set(card,requestAnimationFrame(tick));
      else{frames.delete(card);restore(card);}
    };
    card.style.setProperty('--metric-progress','0');
    frames.set(card,requestAnimationFrame(tick));
  }
  function configure(){
    observer?.disconnect();metricObserver?.disconnect();
    frames.forEach(frame=>cancelAnimationFrame(frame));frames.clear();
    cards.forEach(card=>{card.classList.remove('motion-active');restore(card);});
    if(preference.matches||!('IntersectionObserver' in window))return;
    observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      entry.target.classList.toggle('motion-active',entry.isIntersecting);
    }),{threshold:.18});
    metricObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      const card=entry.target.closest('.study');
      animate(card,cards.indexOf(card));
      metricObserver.unobserve(entry.target);
    }),{threshold:.65});
    cards.forEach((card,index)=>{
      card.style.setProperty('--breath-delay',(-index*1.2)+'s');
      observer.observe(card);metricObserver.observe(card.querySelector('.study-number'));
    });
  }
  configure();
  preference.addEventListener('change',configure);
})();

(function(){
  'use strict';
  const gallery=document.querySelector('[data-ingredient-carousel]');
  if(!gallery||gallery.dataset.ready)return;
  gallery.dataset.ready='true';
  const viewport=gallery.querySelector('[data-origin-viewport]');
  const group=gallery.querySelector('[data-origin-group]');
  const preference=window.matchMedia('(prefers-reduced-motion: reduce)');
  // Keep one card per ingredient, and gently reverse at the ends of the track.
  let maxScroll=0,position=0,frame=0,last=0,direction=1,edgePauseUntil=0;
  let visible=false,hovered=false,focused=false,paused=false,dragging=false,temporaryPause=false;
  let dragX=0,dragScroll=0,dragPointer=null,resumeTimer=0;
  const canMove=()=>visible&&!hovered&&!focused&&!paused&&!dragging&&!temporaryPause&&!preference.matches&&!document.hidden&&maxScroll>0;
  const clamp=value=>Math.max(0,Math.min(maxScroll,value));
  function tick(now){
    frame=0;
    if(!canMove()){last=0;return;}
    if(last&&now>=edgePauseUntil){
      position=clamp(position+direction*Math.min(now-last,64)*.027);
      viewport.scrollLeft=position;
      if(position===0||position===maxScroll){
        direction=position===0?1:-1;
        edgePauseUntil=now+1000;
      }
    }
    last=now;frame=requestAnimationFrame(tick);
  }
  function schedule(){
    cancelAnimationFrame(frame);frame=0;last=0;
    if(canMove()){
      position=clamp(viewport.scrollLeft);
      if(position===0)direction=1;
      else if(position===maxScroll)direction=-1;
      frame=requestAnimationFrame(tick);
    }
  }
  function measure(){
    maxScroll=Math.max(0,viewport.scrollWidth-viewport.clientWidth);
    position=clamp(viewport.scrollLeft);
    viewport.scrollLeft=position;schedule();
  }
  function waitForReading(){
    temporaryPause=true;clearTimeout(resumeTimer);schedule();
    resumeTimer=setTimeout(()=>{temporaryPause=false;schedule();},1400);
  }
  viewport.addEventListener('pointerenter',event=>{if(event.pointerType!=='touch'){hovered=true;schedule();}});
  viewport.addEventListener('pointerleave',event=>{if(event.pointerType!=='touch'){hovered=false;schedule();}});
  viewport.addEventListener('focusin',()=>{focused=true;schedule();});
  viewport.addEventListener('focusout',event=>{if(!viewport.contains(event.relatedTarget)){focused=false;schedule();}});
  viewport.addEventListener('wheel',waitForReading,{passive:true});
  viewport.addEventListener('scroll',()=>{
    if(!canMove())position=viewport.scrollLeft;
    if(temporaryPause&&!dragging){clearTimeout(resumeTimer);resumeTimer=setTimeout(()=>{temporaryPause=false;schedule();},1400);}
  },{passive:true});
  viewport.addEventListener('pointerdown',event=>{
    if(event.pointerType==='mouse'&&event.button!==0)return;
    if(event.pointerType==='touch')paused=true;
    dragging=true;dragPointer=event.pointerId;dragX=event.clientX;dragScroll=viewport.scrollLeft;schedule();
    if(event.pointerType==='mouse'){viewport.setPointerCapture(event.pointerId);event.preventDefault();}
  });
  viewport.addEventListener('pointermove',event=>{
    if(!dragging||event.pointerType!=='mouse'||event.pointerId!==dragPointer)return;
    viewport.scrollLeft=dragScroll-(event.clientX-dragX);position=viewport.scrollLeft;
  });
  function endDrag(event){
    if(!dragging||event.pointerId!==dragPointer)return;
    dragging=false;
    if(viewport.hasPointerCapture(event.pointerId))viewport.releasePointerCapture(event.pointerId);
    dragPointer=null;waitForReading();
  }
  viewport.addEventListener('pointerup',endDrag);
  viewport.addEventListener('pointercancel',endDrag);
  viewport.addEventListener('lostpointercapture',endDrag);
  function step(increment){
    waitForReading();
    const card=group.querySelector('[data-origin-card]');
    const gap=parseFloat(getComputedStyle(group).columnGap)||0;
    const target=clamp(viewport.scrollLeft+increment*(card.getBoundingClientRect().width+gap));
    direction=increment;
    viewport.scrollTo({left:target,behavior:preference.matches?'auto':'smooth'});
  }
  viewport.addEventListener('keydown',event=>{
    if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();step(event.key==='ArrowLeft'?-1:1);}
  });
  document.addEventListener('visibilitychange',schedule);
  preference.addEventListener('change',schedule);
  if('IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>{
      visible=entries[0].isIntersecting;
      if(!visible)paused=false;
      if(visible)gallery.querySelectorAll('img[loading="lazy"]').forEach(image=>{image.loading='eager';});
      schedule();
    },{threshold:.05});
    observer.observe(viewport);
  }else visible=true;
  if('ResizeObserver' in window){const resize=new ResizeObserver(measure);resize.observe(viewport);resize.observe(group);}
  else window.addEventListener('resize',measure,{passive:true});
  measure();
})();
